<template>
  <div class="info">
    <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
      @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  props: {
    userId: Number
  },
  data() {
    return {
      name: 'cdd',
      list: [],
      columns: [
        { label: '时间', prop: 'createTime', minWidth: '120' },
        { label: '订单编号', prop: 'orderNo', minWidth: '120' },
        { label: '类型', prop: 'typeLabel', minWidth: '120' },
        { label: '佣金金额', prop: 'amount', minWidth: '120' },
        {
          label: '状态', prop: 'statusLabel', minWidth: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '已到账' || scope.row.statusLabel == '已提现') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else if (scope.row.statusLabel == '待提现' || scope.row.statusLabel == '未到账') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #C0C0CC;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>

              // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created() {
    this.getCommissionPageList()
  },
  watch: {
    userId: {
      handler(val) {
        this.page.pageNo = 1;
        this.userId = val
        this.getCommissionPageList()
      },
      immediate: true
    }
  },
  methods: {
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getCommissionPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getCommissionPageList()
    },
    getCommissionPageList() {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        id: this.userId
      }
      this.axios.post('/user/userInfo/commission', data)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.info {
  padding-top: 20px;
  padding-bottom: 20px;

  /deep/ .el-table .el-table__header .el-table__cell {
    padding: 0;
  }

  /deep/ .el-table .el-table__row .el-table__cell {
    color: #303033;
    font-weight: 400;
  }
}
</style>

